export const CRM_WEB_PAGES_URLS = {
  root: '',
  auth: 'auth',
  dashboard: {
    list: 'dashboard'
  },
  leads: {
    list: 'leads',
    single: 'leads/:id'
  },
  tasks: {
    list: 'tasks',
    single: 'tasks/:id'
  },
  orderStats: {
    list: 'order-stats'
  },
  users: {
    list: 'users'
  },
  appointments: {
    list: 'appointments',
    calendar: 'appointments/calendar',
    single: 'appointments/:id'
  },
  services: {
    list: 'services',
    single: 'services/:id'
  },
  schedules: {
    list: 'schedules',
    single: 'schedules/:id'
  },
  segment: {
    list: 'segments'
  },
  products: {
    list: 'products'
  },
  coupons: {
    list: 'coupons'
  },
  promotions: {
    list: 'promotions'
  },
  productCategories: {
    list: 'product-categories'
  },
  campaigns: {
    list: 'campaigns'
  },
  layouts: {
    list: 'layouts'
  },
  workflows: {
    list: 'workflows',
    single: 'workflows/:id'
  },
  workflowRuns: {
    list: 'workflow-runs',
    single: 'workflow-runs/:id'
  },
  recurringTasks: {
    list: 'recurring-tasks',
    single: 'recurring-tasks/:id'
  },
  crmSchemas: {
    list: 'schemas'
  },
  forms: {
    list: 'forms'
  },
  onboarding: {
    authStripeToken: 'onboarding/auth-stripe-token'
  },
  emailTemplates: {
    list: 'email-templates',
    single: 'email-templates/:id'
  },
  settings: {
    base: 'settings'
  }
};
Object.freeze(CRM_WEB_PAGES_URLS);
